import type { RoomDef } from '../../sim/types.ts';

/**
 * Room 3 — Hollow (brief §6).
 *
 * The whole floor of the upper chamber is Vine, wall to wall - there is no
 * route around it, only through it. The only way down to the Moonseed and
 * Portal is to cast-destroy the tile directly underfoot (S + Space) and fall
 * through. Rooms 1 and 2 taught create; this teaches that destroy is not just
 * "undo a create" - it opens paths an authored level never gave you any other
 * way into.
 *
 * SCAFFOLD CONTENT (brief §14), same as Rooms 1 and 2.
 */
export const hollow: RoomDef = {
  id: '03-hollow',
  name: 'Hollow',
  map: [
    '################',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#~~~~~~~~~~~~~~#',
    '#..............#',
    '#..............#',
    '#..............#',
    '################',
    '################',
  ],
  spawn: { x: 3.5, y: 6 },
  portal: { tx: 14, ty: 9 },
  items: [
    // Not tx=3: the room-2 lesson applied up front this time - that column
    // overlaps the spawn hitbox and would auto-collect on frame one.
    { kind: 'lumen', tx: 6, ty: 9 },
    { kind: 'moonseed', tx: 10, ty: 9 },
  ],
  chimera: [],
};
